var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 98,
    viewBox: "0 0 130 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1084,
    width: 115.891,
    height: 82.8454,
    rx: 8,
    fill: "#DCF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.426 15.1545H8.26357C6.07193 15.1545 3.97006 16.0274 2.42034 17.581C0.870623 19.1347 0 21.2419 0 23.4391V89.7154C0 91.9126 0.870623 94.0198 2.42034 95.5734C3.97006 97.1271 6.07193 97.9999 8.26357 97.9999H107.426C109.618 97.9999 111.72 97.1271 113.27 95.5734C114.819 94.0198 115.69 91.9126 115.69 89.7154V23.4391C115.69 21.2419 114.819 19.1347 113.27 17.581C111.72 16.0274 109.618 15.1545 107.426 15.1545ZM98.3364 23.4391L57.845 51.5237L17.3535 23.4391H98.3364ZM8.26357 89.7154V27.2085L55.4898 59.9739C56.1815 60.4549 57.0032 60.7127 57.845 60.7127C58.6867 60.7127 59.5084 60.4549 60.2001 59.9739L107.426 27.2085V89.7154H8.26357Z",
    fill: "#00955F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.015b99b00fbc26f5e2fa5c55500d1725.svg";
export { ForwardRef as ReactComponent };